import Vant from 'vant'
import axios from "axios";
import conf from "../config/config";
import cookie from "../utils/cookie";
import { isUndefOrEmpty } from "../utils/util";
import allEventLog from '@/utils/allEventLog';
import router from '../router/index';
import UserLogin from '@/lib/UserLogin';
import httpFn from '@/plugins/uglyhttp';

const service = axios.create({
  timeout: 600000,
  auth: true,
  method: "post",
  loading: true // 是否显示loading
});

const METHOD_MAP = {
  get: "params",
  post: "data",
};

httpFn.defaultSet(service);

service.interceptors.request.use(
  (config) => {
    if(config.url.indexOf('mph5log') >=0){
        config.loading = false;
    }
    if(config.loading) {
      Vant.Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        //message: "加载中..."
      });
    }

    let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
    let streamNo = urlData['streamNo'];  

    if(sessionStorage.getItem('loginStatus') == 'true'){
      let sessionStorage_access_token = sessionStorage.getItem('access_token')
      if(sessionStorage_access_token != cookie.get('access_token')){
        cookie.setCookie('loginCustomerId', urlData['loginCustomerId']);
        cookie.setCookie('mvnoCode', urlData['mvnoCode']);
        cookie.setCookie('orgId', urlData['orgId']);
        cookie.setCookie('access_token', sessionStorage_access_token);
      }  
    }
    

    let authParams = {
      loginCustomerId: urlData['loginCustomerId'],
      mvnoCode: urlData['mvnoCode'] || conf.request.mvnoCode,
      access_token: urlData['access_token'],
      orgId: urlData['orgId'],
      orgCode: urlData['orgCode'],
      channelType:config[METHOD_MAP[config.method]] && config[METHOD_MAP[config.method]].channelType || conf.request.channelType  
    },
    //每次请求后台的流水好不一致，comfrom
    commonParams = {
      streamNo: conf.request.streamNoHead + new Date().getTime() + parseInt(Math.random() * 1000000)|| streamNo,
      partnerCode: conf.request.partnerCode,
      langType: cookie.get('langType') || conf.appDefaultLangType
    };
    

    /*
     * 添加通用参数
     * */
    config.headers["Accept-Language"] = cookie.get("langType") || conf.appDefaultLangType;
    config[METHOD_MAP[config.method]] = {
      ...commonParams,
      ...config[METHOD_MAP[config.method]],
    };
    /*
     * 添加验证参数
     * */
    if (config.auth === true) {
      config[METHOD_MAP[config.method]] = {
        ...config[METHOD_MAP[config.method]],
        ...authParams,
      };
    }
    /*
     * 过滤值为空参数
     * */
    config[METHOD_MAP[config.method]] &&
      Object.keys(config[METHOD_MAP[config.method]]).forEach((val) => {
        if (isUndefOrEmpty(config[METHOD_MAP[config.method]][val])) {
          delete config[METHOD_MAP[config.method]][val];
        }
      });

    return config;
    
  },
  (error) => {
    try{
      allEventLog.comingLog(error,httpFn,"WARN");  
    }catch(e){}
    Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    if(response.config.url.indexOf('mph5log') == -1){
        Vant.Toast.clear();
    }
    //Vant.Toast.clear();

    let resultCode = response.data.resultCode;
    let resultDesc = response.data.resultDesc;

    if (resultCode === "00000000" || (resultCode === '01020040' && response.config.url === '/bss/app/noauth/RegisterUser') || (resultCode === '01020075' && response.config.url === '/bss/app/noauth/GetVerificationCodeBySMS') || (['01020100','01020040'].includes(resultCode) && response.config.url === '/bss/app/noauth/CheckSocialUser') || (['01080141','01080001'].includes(resultCode) && response.config.url === '/bss/app/group/AddGroup')) {
      if(['01080001'].includes(resultCode) && response.config.url === '/bss/app/group/AddGroup'){
        if(response.config.url.indexOf('mph5log') == -1){
            allEventLog.alarmDataLogFn(response, service); 
        }
      }
      return response.data;
    } else {
      if(resultCode === '00000008' || resultCode === '00000007' || resultCode === '00000006' || resultCode === '01261047') {
        /*
         * 00000008 => AccessToken does not belong to the loginCustomer
         * 00000007 => The access token expired
         * 00000006 => AccessToken is null
         * token问题时通知app，app静默登录后重新加载当前页面
         * */
         
        cookie.clearCookie("access_token"); 
        window.dsBridge.call('nativeLogin');
        //h5登录超时重新登录页面，登录完成重新加载当前页面
        UserLogin.setAppThat(httpFn).gotoLogin();

      } else {

        if(response.config.url.indexOf('mph5log') == -1){
            allEventLog.alarmDataLogFn(response, service); 
        }
        Vant.Toast(resultDesc)
        return Promise.reject(resultDesc);
      }      
    }
  },
  (error) => {
    // 失败执行
    if (error.response) {
        if(error.response.config.url.indexOf('mph5log') == -1){
            allEventLog.alarmDataLogFn(error.response, service); 
            Vant.Toast.clear();
        }
    }

    
    router.push({
      name: 'NetError'
    });
    
    // 展示app的无网络页面
    //window.dsBridge.call('showNoNetwork');  
    
    return Promise.reject('');
  }
);

export default service;
